var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal_wrapper"},[_c('div',{staticClass:"modal notifications"},[_c('a',{staticClass:"model-close-btn",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.close}},[_vm._v("x")]),_vm._v(" "),_c('div',{staticClass:"body"},[_c('div',{staticClass:"content mb-2",domProps:{"innerHTML":_vm._s(_vm.content)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ab60b54","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal-notification.vue
// module id = 817
// module chunks = 0